var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "modal-wrapper",
    class: {
      open: _vm.value,
      mobile: _vm.isMobile,
      reverse: _vm.infoModal
    }
  }, [_c('div', {
    staticClass: "overlay",
    on: {
      "click": function click($event) {
        return _vm.closeModal(false);
      }
    }
  }), _c('div', {
    staticClass: "modal-inner"
  }, [_vm.isMobile ? _c('div', {
    directives: [{
      name: "hammer",
      rawName: "v-hammer:swipe.vertical",
      value: _vm.onSwipe,
      expression: "onSwipe",
      arg: "swipe",
      modifiers: {
        "vertical": true
      }
    }],
    staticClass: "modal-line-wrapper"
  }, [_c('div', {
    staticClass: "modal-line"
  })]) : _c('v-btn', {
    staticClass: "modal-close",
    attrs: {
      "text": ""
    },
    on: {
      "click": function click($event) {
        return _vm.closeModal(false);
      }
    }
  }, [_c('v-icon', [_vm._v(" mdi-close ")])], 1), _c('div', {
    staticClass: "modal-content"
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "modal-fixed-content"
  }, [_vm._t("fixedContent")], 2)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }